<template>
    <div class="p-3 delegation advanced-search bg-white rounded-12px">
        <div class="d-flex flex-wrap align-items-center gap-3 ml-3" v-if="!showAdvancedSearchDialogFlag && !utils.CheckIfNullOrEmpty(filters)">
            <v-icon class="mx-1" style="width: 25px;">mdi-magnify</v-icon>
            <v-text-field class="m-0 align-items-center cts-field" v-model="filters.combineFilter" solo
                          :label="$t('res_Label_EnterSubjectOrReferenceNumber')"
                          @click:prepend="refreshPageGrid()" @keydown.enter="refreshPageGrid()">
            </v-text-field>
            <v-btn dense @click="refreshPageGrid()" class="primary">{{ $t("res_ButtonText_Search") }}</v-btn>
            <v-btn class="primary" @click="showAdvancedSearchDialog()"><v-icon>mdi-chevron-down</v-icon></v-btn>
        </div>
        <div :style="{ display: showAdvancedSearchDialogFlag ? 'block' : 'none' }">
            <AdvancedSearchFilters :filter="filters"
                                   :language="language"
                                   :applyFiltersOnReset="true"
                                   @applyFilters="applyFilters"
                                   @showAdvancedSearchDialogEvent="showAdvancedSearchDialog()">
            </AdvancedSearchFilters>
        </div>
        <div>
            <div class="p-0 flex-1 overflow-auto tab-content mt-2 panel d-flex flex-wrap gap-2">

                <div class="cts-pane">
                    <!--table-->
                    <!-- remove single-select in sprint 2 -->
                    <v-data-table v-if="correspondences.length" :mobile-breakpoint="0" :headers="grid_headers" v-model="selected"
                                  :items="correspondences" :items-per-page="pagingData.pageSize" item-key="transferId"
                                  hide-default-footer class="elevation-1 empty-full-height cts-grid" show-select
                                  single-select :sort-by.sync="sortBy"
                                  :item-class="getRowClass" @dblclick:row="openFullView"
                                  @click:row="previewCorrespondence" @item-selected="itemSelected"
                                  @update:sort-by="updateSortBy" @update:sort-desc="updateSortDesc" must-sort>
                        <template v-slot:item.pinned="{ item }">
                            <v-icon @click="item.pinned = !item.pinned">{{ getPinned(item) }} </v-icon>
                        </template>
                        <template v-slot:item.overdue="{ item }">
                            <label class="float-end text-warning mx-2 d-flex">
                                <v-icon>{{ utils.getOverDue(item.overdue, nodeId) }}</v-icon> {{
                                                    utils.getOverdueDays(item.overdue, item.overdueDays, nodeId)
                                }}
                            </label>
                        </template>
                        <template v-slot:item.status="{ item }">
                            <v-chip dark v-bind:class=getStatusClass(item) text-color="black">{{ item.status }}</v-chip>
                        </template>
                        <template v-slot:item.purpose="{ item }">
                            <v-chip dark v-bind:color=getPurposeColor(item) text-color="black">{{ item.purpose }}</v-chip>
                        </template>
                        <template v-slot:item.hasAttachment="{ item }">
                            <v-icon>{{ getAttachment(item.hasAttachment) }}</v-icon>
                        </template>
                        <template v-slot:item.subject="{ item }">
                            <div class="d-flex align-items-center">
                                <span class="mdi mdi-content-copy copy-icon" v-if="item.subject" @click.stop="utils.copyToClipboard(item.subject, 'res_Msgs_SubjectCopied')" v-tooltip="$t('res_Label_CopySubject')"></span>
                                <span class="subjectCell" v-tooltip="item.subject.length > 50 ? item.subject : ''">{{ utils.trimText(item.subject, 50) }}</span>
                            </div>
                        </template>
                        <template v-slot:item.referenceNumber="{ item }">
                            <div class="d-flex align-items-center">
                                <span class="mdi mdi-content-copy copy-icon" v-if="item.referenceNumber" @click.stop="utils.copyToClipboard(item.referenceNumber, 'res_Msgs_ReferenceNumberCopied')" v-tooltip="$t('res_Label_CopyReferenceNumber')"></span>
                                <span class="text-limit" v-tooltip="item.referenceNumber">{{ item.referenceNumber }}</span>
                            </div>
                        </template>
                        <template v-slot:item.sender="{ item }">
                            <span class="text-limit" v-tooltip="item.sender">{{ item.sender }}</span>
                        </template>
                        <template v-slot:item.receiverEntity="{ item }">
                            <span v-tooltip="item.receiverEntity && item.receiverEntity.length > 50 ? item.receiverEntity : ''"><span v-for="(recipient, index) in utils.trimText(item.receiverEntity, 50).split(',')" :key="index"><strong v-if="index > 0">,</strong>{{ recipient }}</span></span>
                        </template>
                        <template v-slot:item.receivedDate="{ item }">
                            {{constants.showDateWithTime? utils.formatDateTimeWithTime(item.receivedDate) : utils.formatDateTime(item.receivedDate)  }}
                        </template>
                        <template v-slot:item.createdDate="{ item }">
                            {{ utils.formatDateTime(item.createdDate) }}
                        </template>
                        <!--<template v-slot:no-data>
                            <div class="cts-empty">
                                <img src="/assets/images/empty-inbox.svg" alt="" />
                                <p v-if="!hasSearched">{{ $t("res_Msgs_EmptySearch") }}</p>
                                <template v-else>
                                    <p>{{ $t("res_Msgs_GetAllCaughtUp") }}</p>
                                    <p>{{ $t("res_Msgs_NoNewItem") }}</p>
                                </template>
                            </div>
                        </template>-->
                        <template v-slot:[`item.actions`]="{ item }">
                            <div class="d-flex gap-2 justify-content-end" @click="openVisualTrackingFromInbox(item.documentId)" style="cursor:pointer !important">
                                <div class="custom-icon-wrapper" v-tooltip="$t('res_ButtonText_VisualTracking')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24">
                                        <path fill="#667593" d="M19 20.5q-.898 0-1.586-.562t-.855-1.438H11q-1.458 0-2.479-1.021T7.5 15t1.021-2.479T11 11.5h2q1.031 0 1.766-.735q.734-.736.734-1.769t-.734-1.764T13 6.5H7.44q-.17.875-.856 1.438T5 8.5q-1.042 0-1.77-.728q-.73-.729-.73-1.77t.73-1.771T5 3.5q.898 0 1.584.563q.685.562.857 1.437H13q1.458 0 2.479 1.021T16.5 9t-1.021 2.479T13 12.5h-2q-1.031 0-1.766.736q-.734.735-.734 1.768t.735 1.764q.734.732 1.765.732h5.56q.17-.875.856-1.437T19 15.5q1.042 0 1.77.729q.73.728.73 1.769t-.73 1.771T19 20.5M5 7.5q.617 0 1.059-.441Q6.5 6.617 6.5 6t-.441-1.059Q5.617 4.5 5 4.5t-1.059.441Q3.5 5.383 3.5 6t.441 1.059Q4.383 7.5 5 7.5" />
                                    </svg>
                                </div>
                            </div>
                        </template>
                        <template v-slot:[`item.transfersItems`]="{ item }">
                            <div class="d-flex gap-2 justify-content-end"
                                 @click.stop="openTransfersDialog(item.documentId)"
                                 @keydown.enter.stop.prevent="openTransfersDialog(item.documentId)"
                                 role="button"
                                 tabindex="0"
                                 style="cursor:pointer !important">
                                <div class="custom-icon-wrapper" v-tooltip="$t('res_Label_ViewAllCorrespondances')">
                                    <svg fill="#000000" width="30px" height="30px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.25 6.12V4.87h-7l3-2.05-.71-1L.59 4.45A1.29 1.29 0 0 0 0 5.5a1.29 1.29 0 0 0 .59 1l3.93 2.72.71-1-3-2.06zm6.16 3.33-3.93-2.67-.71 1 3 2.06h-7v1.25h7.03l-3 2 .71 1 3.93-2.67a1.23 1.23 0 0 0 0-2.1z" />
                                    </svg>
                                </div>
                            </div>
                        </template>
                    </v-data-table>

                    <div v-else class="cts-empty">
                        <img src="/assets/images/empty-inbox.svg" alt="" />
                        <p class="m-0" v-if="!hasSearched">{{ $t("res_Msgs_EmptySearch") }}</p>
                        <template v-else>
                            <p class="m-0">{{ $t("res_Msgs_GetAllCaughtUp") }}</p>
                            <p class="m-0">{{ $t("res_Msgs_NoNewItem") }}</p>
                        </template>
                    </div>
                </div>
                <div class="cts-pane py-2" v-if="openPreviewPane">
                    <div class="h-100"
                         style="background: #EFF2F5; border-radius: 12px; position: relative; overflow: hidden">
                        <div>
                            <v-btn class="close-btn d-block bg-white close-viewer " icon
                                   @click="closePreview()">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                        <!--viewer section-->
                        <div class=" position-relative viewer-container scrollable-container"
                             style="height: calc(100vh - 176px - 1rem); overflow-y: hidden;">
                            <div v-if="empty_viewer" class="empty-viewer"
                                 style="border-radius: 12px; height: calc(100vh - 176px);">
                                <img src="/assets/images/icons/template.svg" />
                                <img src="/assets/images/icons/no_preview.svg" />
                                <p class="mt-4 weight-400">{{ $t("res_Msgs_NoPreviewAvailable") }}</p>
                            </div>
                            <div v-if="!empty_viewer" id="viewer_template" class="h-100"
                                 style="border-radius: 12px;">
                                <iframe id="viewerFrame" :src="viewerFrame" class="w-100"></iframe>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>


        <v-dialog v-model="visualTrackingDialog" content-class="tracker-container dialog with-sticky-actions bg-white"
                  width="100%" fullscreen>
            <div class="dialog-header">
                <!-- <v-icon class="back-btn">mdi-chevron-left</v-icon> -->
                <v-btn class="close-btn light-btn tracker-close" icon dark @click="visualTrackingDialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <div class="dialog-body h-100">
                <iframe id="trackingFrame" :src="trackingFrameSrc"
                        style="width: 100%; height: 100%; min-height: 1000px;"></iframe>
            </div>
        </v-dialog>

        <v-dialog v-model="showTransfersListDialog" content-class="bg-white fullscreen-dialog overflow-hidden" width="100%" :persistent="true" fullscreen>
            <TransfersItems :key="transferComponentKey" :document-id="selectedDocumentId"
                            @view-document="handleViewDocument"
                            @close-dialog="showTransfersListDialog = false" />
        </v-dialog>

        <v-dialog v-model="correspondenceDialog" content-class="create-document-dialog fullscreen-dialog corr_dialog"
                  fullscreen :persistent="true">
            <div id="correspondenceDialogEmptyDiv"></div>
            <CreateDocumentView v-if="correspondenceDialog" :documentId="documentId" :transferId="transferId" :viewMode="viewMode"
                                :delegationId="delegationId" :toEmail="toEmail" :emailCC="emailCC" :isOpenedFromAdvancedSearch="true"
                                :closeDialogEvent="closeCorrespondenceDialog" :openedFromNodeId="nodeId" />
        </v-dialog>
        <div class="d-flex align-items-center mt-2">
            <Pagination :totalCount="this.inboxes[0].count" :pageSize="pagingData.pageSize" :pageIndex="pagingData.pageIndex"
                        @pageIndexChanged="pageIndexChanged" :showPageSize="false" :showMargin="false"></Pagination>
            <div v-if="this.inboxes[0].count">
                <v-btn class="custom-button" @click="exportToExcelOrPdf(1)" v-tooltip="$t('res_Export_To_Excel')"><v-icon class="bg-gray black--text custom-button" style="color: #388729 !important; background-image: none;">mdi-file-excel</v-icon></v-btn>
                <v-btn class="custom-button" @click="exportToExcelOrPdf(2)" v-tooltip="$t('res_Export_To_Pdf')"><v-icon class="bg-gray custom-button">mdi-file-pdf-box</v-icon></v-btn>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import constants from '@/assets/js/constants'
    import { getTransferPurposes } from '@/store/modules/lookups.js'
    import CreateDocumentView from '@/views/CreateDocumentView.vue'
    import { defaultGet } from '@/assets/js/common.js'
    import TransferForm from '@/components/TransferForm.vue'
    import SigningHistory from '@/components/SigningHistory.vue'
    import TrackingTree from '@/components/TrackingTree.vue'
    import * as utils from '@/assets/js/common.js'
    import NotifyEmail from '@/components/NotifyEmail.vue'
    import TransfersItems from '@/components/TransfersItems.vue'
    import EmailDispatchDocumentForm from '@/components/EmailDispatchDocumentForm.vue'
    import Sign from '@/components/Sign.vue'
    import Pagination from '@/components/Pagination.vue'
    import TransferNotesIcon from '@/components/TransferNotesIcon.vue'
    import StructureUserSelector from '@/components/StructureUserSelector.vue'
    import Multiselect from 'vue-multiselect'
    import router from '../router/index.js';
    import AdvancedSearchFilters from '@/components/AdvancedSearchFilters.vue';
    import { MAX_NODES_MESS } from '@/assets/js/orgchart.js';

    export default {
        name: 'AdvancedSearch',
        components: { Multiselect, StructureUserSelector, CreateDocumentView, TransferForm, SigningHistory, TrackingTree, NotifyEmail, EmailDispatchDocumentForm, Sign, Pagination, TransferNotesIcon, AdvancedSearchFilters, TransfersItems },
        props:
        {
            nodeId: { type: Number, default: 11 }
        },
        data() {
            const vm = this;
            return {
                signingHistoryDialog: false,
                trackingFrameSrc: '',
                visualTrackingDialog: false,
                visualTrackingDialogNew_selectedDocumentId: 0,
                visualTrackingDialogNew: 0,
                showTransfersListDialog: false,
                selectedDocumentId: null,
                transferComponentKey: 0,
                router: router,
                isLanguageEn: true,
                offset: true,
                loading: false,
                action_types: [],
                from_date_datePicker: false,
                to_date_datePicker: false,
                hideSpinner: false,
                isExport: false,
                exportType: '',
                structureCategories: [{ id: '1', name: 'Incoming' }, { id: '2', name: 'Outgoing' }, { id: '3', name: 'Internal' }],
                privacies: [],
                priorities: [],

                /*sort by pinned*/
                sortBy: 'id',
                sortDesc: true,

                selected_node_id: 0,
                correspondences: [],
                hasSearched: false,
                selectedItem: null,
                selected: [],

                grid_headers: [
                ],
                openPreviewPane: false,
                viewerFrame: '',
                empty_viewer: true,

                inboxes: [{ id: 1, name: 'My Inbox', inboxId: 1, delegationId: 0, count: 0 }],
                selected_node: {},
                selected_index: 0,
                delegationId: 0,

                correspondenceDialog: false,
                documentId: 0,
                transferId: 0,
                viewMode: 'readonly',

                purpose: {},

                referenceNumber: "",

                toEmail: "",
                emailCC: "",
                utils: utils,
                constants: constants,
                pagingData: {
                    pageSize: 20,
                    pageIndex: 0
                },

                nowDate: new Date().toISOString().slice(0, 10),
                showAdvancedSearchDialogFlag: false,
                filters: {
                    combineFilter: "",
                    subject: "",
                    referenceNumber: "",
                    fromDate: "2026-01-01",
                    toDate: "",
                    documentSender: null,
                    documentRecipient: null,
                    fromStructure: null,
                    toStructure: null,
                    fromUser: null,
                    toUser: null,
                    category: null,
                    privacyLevel: null,
                    priorityLevel: null,
                    status: null,
                    receivedDate: "",
                    content: "",
                    tags: "",
                    links: "",
                    template: [],
                    note: "",
                    RejectedByMe: false,
                    ArchivedByMe: false,
                    SignedByMe: false,
                    keywords: ""
                },
                language: 'en',
                roleId: JSON.parse(sessionStorage.getItem("user")).profile.ApplicationRoleId,
                page: 1,
                purposes: getTransferPurposes()
            };
        },
        computed:
        {
            // totalPages()
            // {
            //     return Math.max(1, Math.ceil(this.correspondences.length / this.pagingData.pageSize));
            // },

            // pagedItems() {
            //     const start = (this.page - 1) * this.pagingData.pageSize;
            //     return this.correspondences.slice(start, start + this.pagingData.pageSize);
            // }
        },
        beforeMount() {

        },
        mounted() {
            this.language = localStorage.getItem('lang');
            this.inboxes = [{ id: 1, name: window.translate("res_TabsName_Inbox"), inboxId: 1, delegationId: 0, count: 0 }]
            this.grid_headers = [
                { text: '', value: 'data-table-select' },
                { text: window.translate("res_GridHeaders_CreatedSubject"), value: 'subject', sortable: false },
                { text: window.translate("res_MenuItems_ReferenceNumber"), value: 'referenceNumber', sortable: false },
                { text: '', value: 'Overdue', sortable: false },
                { text: window.translate("res_Label_CreatedBy"), value: 'createdBy', sortable: false },
                { text: window.translate("res_GridHeaders_FromUser"), value: 'fromUser', sortable: false },
                { text: window.translate("res_GridHeaders_FromStructure"), value: 'sender', sortable: false },
                { text: window.translate("res_GridHeaders_ToUser"), value: 'toUser', sortable: false },
                { text: window.translate("res_GridHeaders_ToStructure"), value: 'toStructure', sortable: false },
                { text: window.translate("res_Label_DocumentSender"), value: 'sendingEntity', sortable: false },
                { text: window.translate("res_Label_DocumentRecipient"), value: 'receiverEntity', sortable: false },
                { text: window.translate("res_GridHeaders_ActionType"), value: 'purpose', sortable: false },
                { text: window.translate("res_GridHeader_Status"), value: 'status', sortable: false },
                { text: window.translate("res_GridHeader_Category"), value: 'category', sortable: false },
                { text: window.translate("res_GridHeaders_Recieved"), value: 'receivedDate', sortable: true },
                { text: '', value: 'actions', sortable: false },
                { text: '', value: 'transfersItems', sortable: false },

            ]

            this.privacies = constants.privacies;
            this.priorities = constants.priorities;

            var searchHandedOver = false;
            if (this.$route.query.fromSession) {
                if (!utils.CheckIfNullOrEmpty(sessionStorage.getItem('advanced_search_filters'))) {
                    this.filters = utils.copyObject(JSON.parse(sessionStorage.getItem('advanced_search_filters')), this.filters);
                    sessionStorage.setItem('advanced_search_filters', '');
                    searchHandedOver = true;
                }
            }

            if (searchHandedOver)
                this.applyFilters();
        },
        beforeDestroy() {
            sessionStorage.removeItem('advanced_search_filters');
        },
        methods: {
            openVisualTrackingFromInbox(documentId = 0) {
                if (window.enableVisualTracker2 == true) {
                    this.visualTrackingDialogNew_selectedDocumentId = documentId > 0 ? documentId : this.selectedItem.item.documentId;
                    this.visualTrackingDialogNew = true;
                }
                else {
                    this.signingHistoryDialog = false
                    var lang = localStorage.getItem('lang')
                    lang = ((lang == null || lang == undefined) ? 'en' : lang);
                    window.setVisualTrackingData(documentId > 0 ? documentId : this.selectedItem.item.documentId);
                    this.trackingFrameSrc = "/resources/VisualTracking/VisualTracking.html?lang=" + lang + "&r=" + new Date().getTime()
                    this.visualTrackingDialog = true
                }
            },
            openTransfersDialog(documentId) {
                this.selectedDocumentId = documentId
                // increment key so Vue will recreate the component instance
                this.transferComponentKey = (this.transferComponentKey || 0) + 1
                this.showTransfersListDialog = true
            },
            applyFilters(updatedFilters) {
                this.closePreview();
                if (utils.CheckIfNullOrEmpty(updatedFilters)) {
                    this.selected = []
                    this.initPage(0)
                }
                else {
                    this.filters = updatedFilters;
                    this.getItemsForSelectedInbox(true);
                }
            },
            clearAndResetFilters() {
                this.filters = {
                    combineFilter: "",
                    subject: "",
                    referenceNumber: "",
                    fromDate: "2026-01-01",
                    toDate: "",
                    documentSender: null,
                    documentRecipient: null,
                    fromStructure: null,
                    toStructure: null,
                    fromUser: null,
                    toUser: null,
                    createdBy: null,
                    category: null,
                    privacyLevel: null,
                    priorityLevel: null,
                    status: null,
                    receivedDate: "",
                    content: "",
                    contentSelectedYear: new Date().getFullYear(),
                    tags: "",
                    links: "",
                    template: [],
                    note: "",
                    RejectedByMe: false,
                    ArchivedByMe: false,
                    SignedByMe: false,
                    keywords: ""
                }
            },
            setStructure(item, type) {
                if (type == 1)
                    this.filters.fromStructure = item;
                else
                    this.filters.toStructure = item
            },
            setUser(selectedUserItem, type) {
                const value = selectedUserItem == null ? null : { ...selectedUserItem, id: selectedUserItem.id.toString().split('-')[0] };
                if (type == 1) this.filters.fromUser = value;
                else this.filters.toUser = value;
            },
            exportToExcelOrPdf(exportType) {
                this.isExport = true;
                this.exportType = exportType;
                var extension = exportType == 1 ? '.xlsx' : '.pdf';
                var query = this.prepareSearchAndExportQuery();

                if (!this.hideSpinner)
                    window.showLoading();

                axios({
                    url: constants.baseApiUrl + `Transfer/AdvancedSearch`,
                    method: 'POST',
                    responseType: 'blob',
                    data: query
                })
                    .then((res) => {
                        var blob = new Blob([res.data], { type: "application/octetstream" });
                        const link = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.setAttribute("download", "ExportedData" + `${extension}`);
                        a.setAttribute("href", link);
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    })
                    .catch(() => { })
                    .finally(f => {
                        !this.hideSpinner ? window.hideLoading() : this.hideSpinner = !this.hideSpinner;
                    });
                this.isExport = false;
                this.exportType = '';
            },
            preapareCombinedFilter(queryObject) {
                if (utils.CheckIfNullOrEmpty(this.filters.combineFilter)) {
                    return;
                }

                const tokens = this.filters.combineFilter.split(',');
                const subjectToken = (tokens[0] || '').trim();
                const referenceToken = (tokens[1] || '').trim();

                if (subjectToken && !queryObject.subject) {
                    queryObject.subject = subjectToken;
                }

                if (referenceToken) {
                    if (!queryObject.referenceNumber) {
                        queryObject.referenceNumber = referenceToken;
                    }
                } else if (tokens.length === 1 && subjectToken && !queryObject.referenceNumber) {
                    queryObject.referenceNumber = subjectToken;
                }
            },
            prepareSearchAndExportQuery() {
                const queryObject = {};

                queryObject.delegationId = !utils.CheckIfNullOrEmpty(this.selected_node) && !utils.CheckIfNullOrEmpty(this.selected_node.id)
                    ? this.selected_node.delegationId
                    : 0;

                queryObject.pageIndex = this.pagingData.pageIndex;
                queryObject.pageSize = this.pagingData.pageSize;
                queryObject.sortBy = this.sortBy;
                queryObject.sortDir = this.sortDesc ? 'desc' : 'asc';
                queryObject.enableAdvancedSearch = this.showAdvancedSearchDialogFlag;

                this.preapareCombinedFilter(queryObject);

                if (!utils.CheckIfNullOrEmpty(this.filters.subject)) {
                    queryObject.subject = this.filters.subject;
                }

                if (!utils.CheckIfNullOrEmpty(this.filters.referenceNumber)) {
                    queryObject.referenceNumber = this.filters.referenceNumber;
                }

                if (!utils.CheckIfNullOrEmpty(this.filters.fromDate)) {
                    queryObject.fromDate = this.filters.fromDate;
                }

                if (!utils.CheckIfNullOrEmpty(this.filters.toDate)) {
                    queryObject.toDate = this.filters.toDate;
                }

                if (this.filters.fromStructure?.id > 0) {
                    queryObject.FromStructureId = this.filters.fromStructure.id;
                }

                if (this.filters.toStructure?.id > 0) {
                    queryObject.toStructureId = this.filters.toStructure.id;
                }

                if (this.filters.documentSender?.id > 0) {
                    queryObject.documentSenderId = this.filters.documentSender.id;
                }

                if (this.filters.documentRecipient?.id > 0) {
                    queryObject.documentRecipientId = this.filters.documentRecipient.id;
                }

                if (this.filters.fromUser?.id > 0) {
                    queryObject.fromUserId = this.filters.fromUser.id;
                }

                if (this.filters.toUser?.id > 0) {
                    queryObject.toUserId = this.filters.toUser.id;
                }

                if (this.filters.createdBy?.id > 0) {
                    queryObject.createdById = this.filters.createdBy.id;
                }

                if (this.filters.category?.id > 0) {
                    queryObject.categoryId = this.filters.category.id;
                }

                if (this.filters.privacyLevel?.id > 0) {
                    queryObject.privacyId = this.filters.privacyLevel.id;
                }

                if (this.filters.priorityLevel?.id > 0) {
                    queryObject.priorityId = this.filters.priorityLevel.id;
                }

                if (this.filters.status?.id > 0) {
                    queryObject.statusId = this.filters.status.id;
                }

                if (this.filters.template && this.filters.template.length > 0) {
                    queryObject.templateIds = this.filters.template.filter(x => x.id != 0).map(x => x.id).join(',');
                }

                if (!utils.CheckIfNullOrEmpty(this.filters.links)) {
                    queryObject.links = this.filters.links;
                }

                if (!utils.CheckIfNullOrEmpty(this.filters.tags)) {
                    queryObject.tags = this.filters.tags;
                }

                if (!utils.CheckIfNullOrEmpty(this.filters.content)) {
                    queryObject.content = this.filters.content;
                }

                if (!utils.CheckIfNullOrEmpty(this.filters.contentSelectedYear)) {
                    queryObject.contentSelectedYear = this.filters.contentSelectedYear;
                }

                if (!utils.CheckIfNullOrEmpty(this.filters.note) === false) {
                    queryObject.note = this.filters.note;
                }

                if (!utils.CheckIfNullOrEmpty(this.filters.keywords)) {
                    queryObject.keywords = this.filters.keywords;
                }

                queryObject.signedByMe = this.filters.SignedByMe;
                queryObject.archivedByMe = this.filters.ArchivedByMe;
                queryObject.rejectedByMe = this.filters.RejectedByMe;

                if (!utils.CheckIfNullOrEmpty(this.filters.HrmsEmployeeId))
                    queryObject.HrmsEmployeeId = this.filters.HrmsEmployeeId;

                if (this.isExport) {
                    queryObject.isExport = this.isExport;
                    queryObject.exportType = this.exportType;
                }

                return queryObject;
            },
            initPage(ifGrid) {
                // 1: draft, 2: inbox, 6: sent, 8: archive, 9: followup
                if (document.querySelectorAll('.v-application--is-rtl').length)
                    this.isLanguageEn = false

                if (ifGrid == 0) {
                    this.pageIndex = 0
                }

                this.getItemsForSelectedInbox(true)
            },
            getItemsForSelectedInbox(isResetPaging) {
                this.hasSearched = true;

                if (isResetPaging) {
                    this.pagingData.pageIndex = 0;
                }

                // if(!this.showAdvancedSearchDialogFlag && (this.filters.subject == null || this.filters.subject== ''))
                //     return;

                var query = this.prepareSearchAndExportQuery();
                if (!this.hideSpinner)
                    window.showLoading();

                axios.post(constants.baseApiUrl + `Transfer/AdvancedSearch`, query)
                    .then(res => {
                        if (utils.CheckIfNullOrEmpty(res))
                            return window.showAlert('res_Msgs_ErrorOccured', 'error');

                        // the SP returns the requested page already paged and sorted,
                        // one row per document, with the grand total on every row
                        this.correspondences = res.data || [];
                        var totalCount = this.correspondences.length ? this.correspondences[0].totalCount : 0;

                        if (!utils.CheckIfNullOrEmpty(this.selected_node) && !utils.CheckIfNullOrEmpty(this.selected_node.id)) {
                            var index = this.inboxes.findIndex(x => x.id == this.selected_node.id)
                            this.inboxes[index].count = totalCount;
                        }
                        else
                            this.inboxes[0].count = totalCount;

                        setTimeout(() => { this.showTooltips() }, 1000);

                    })
                    .catch((err) => console.log(err))
                    .finally(() => !this.hideSpinner ? window.hideLoading() : this.hideSpinner = !this.hideSpinner);
            },
            getItemsCountForSelectedInbox(nodeId, delegationId, successHandler) {

                var request = {
                    NodeId: nodeId,
                    DelegationId: delegationId,
                    PageIndex: this.pagingData.pageIndex,
                    PageSize: this.pagingData.pageSize,
                    GetCountOnly: true,
                }

                axios.post(constants.baseApiUrl + 'Transfer/List', request)
                    .then((res) => {
                        successHandler(res.data)
                    });
            },
            getPinned(item) {
                // if (item.pinned)
                //     return 'mdi-pin'
                // else
                //     return 'mdi-light-pin'
                var isNotRead = (this.getRowClass(item).lastIndexOf('tr-bold') != -1 ? true : false)
                if (isNotRead)
                    return 'mdi-not-read'
                else
                    return ''
            },
            getStatusClass(item) {
                if (window.statuses != undefined) {
                    var statusItem = window.statuses.find(x => x.id == item.statusId)
                    if (statusItem != null)
                        return statusItem.color;
                }
                return ''
            },
            getPurposeColor(item) {
                var purposeItem = this.purposes.find(x => x.id == item.purposeId)
                if (purposeItem != null)
                    return purposeItem.color
                return ''
            },
            getAttachment(hasAttachment) {
                if (hasAttachment == true) return 'mdi-attachment'
            },
            previewCorrespondence(item, row) {
                if (this.roleId != 11 || this.roleId != 2) {
                    if (!item.openedForPreview) {
                        item.openedForPreview = true;
                    }

                    this.selected = []
                    this.selectedItem = { 'item': item, 'value': true }
                    this.openPreviewPane = true

                    if (item.attachmentId == null || item.attachmentId == undefined) {
                        this.empty_viewer = true
                    }
                    else {
                        this.empty_viewer = false
                        window.setViewerData(item.attachmentId, item.documentId);
                        this.viewerFrame = '/resources/viewer/viewer.html?lang=' + this.$i18n.locale + '&defaultScale=page-fit&pageMode=view' +
                            '&viewerMode=collapsed&hideEditInWord=true&r=' + new Date().getTime()
                    }
                }
            },
            openFullView() {
                //  Draft = 1, Inbox = 2, Sent = 6, Archived = 8, Follow-up = 9
                this.viewMode = 'readonly'
                var item = this.selectedItem.item
                if (item.statusId == 1) // Draft
                {
                    this.delegationId = 0
                    this.documentId = item.id
                    this.correspondenceDialog = true
                }
                else {
                    this.nodeId = item.nodeId
                    this.delegationId = this.selected_node.delegationId
                    this.transferId = item.transferId
                    this.documentId = item.documentId
                    this.correspondenceDialog = true
                    setTimeout(() => {
                        //document.getElementById('correspondenceDialogEmptyDiv').parentElement.classList.add('view-mode-dialog');
                        document.getElementById('correspondenceDialogEmptyDiv').parentElement.parentElement.classList.add('transparentBg');
                    }, 10);
                }

                if (this.nodeId == 9) {
                    this.toEmail = item.sentToEmail
                    this.emailCC = item.sentToManagerEmail
                }

                this.closePreview();
            },
            itemSelected(item, value) {
                if (item.value == true) {
                    this.selectedItem = item
                }
                else {
                    this.selectedItem = null
                }
            },
            closePreview() {
                this.selectedItem = null
                this.openPreviewPane = false
            },
            refreshPage() {
                this.selected = []
                this.closePreview();
                this.initPage(0);
            },
            refreshPageGrid() {
                this.selected = []
                this.closePreview();
                this.filters.enableAdvancedSearch = false;
                this.initPage(1);
            },
            getInboxName(isLanguageEn, isDelegation) {
                switch (this.nodeId) {
                    case 1:
                        return isLanguageEn ? 'Draft' : 'المسودات';
                    case 2:
                        return isLanguageEn ? 'Inbox' : 'صندوق المراسلات';
                    case 6:
                        return isLanguageEn ? 'Sent' : 'المرسل';
                    case 7:
                        return isLanguageEn ? 'Hidden' : 'المخفي';
                    case 8:
                        return isLanguageEn ? 'Archive' : 'الأرشيف';
                    case 9:
                        return isLanguageEn ? 'Follow up' : 'متابعة';
                    case 10:
                        return isLanguageEn ? 'Cced Inbox' : 'النسخ';
                    case 4:
                        return isLanguageEn ? 'Via Email' : 'عبر البريد الاكتروني';
                    default:
                        return 'Inbox'
                }
            },
            closeCorrespondenceDialog() {
                this.delegationId = 0
                this.documentId = 0
                this.transferId = 0
                this.correspondenceDialog = false

                //this.getItemsForSelectedInbox(false)
            },
            openDeliveryNote() {
                this.documentId = this.selectedItem.item.documentId;

                axios.get(constants.baseApiUrl + 'DeliveryNote/GetDeliveryNoteData?documentId=' + this.documentId)
                    .then((res) => {
                        if (res.data == true) {
                            window.showAlert('res_Msgs_DeliveryNoteCreationValidation', 'warning')
                        }
                        else {
                            this.referenceNumber = this.selectedItem.item.referenceNumber;
                        }
                    })
                    .catch((err) => { console.log(err); window.hideLoading(); })
            },
            getRowClass(item) {
                var retVal = ''
                if (item.openedDate || item.closedDate || item.openedForPreview || this.nodeId != 2)
                    retVal = ''
                else
                    retVal = 'tr-bold'

                if (this.selectedItem != null && this.selectedItem.item != null && item == this.selectedItem.item) {
                    this.selectedItem.value = true
                    retVal += 'custom-class'
                }

                return retVal
            },
            showTooltip(text) {
                const element = this.$refs.ellipsisElements;
                if (element) {
                    element.textContent = text;
                    return element.offsetHeight < element.scrollHeight;
                }

                return false;
            },
            showTooltips() {
                var elements = document.getElementsByClassName('td-text-limit');
                for (var i = 0; i < elements.length;) {
                    var element1 = elements[i];
                    var element2 = elements[i + 1];
                    var showTooltip = element1.offsetHeight < element1.scrollHeight;
                    if (element1.id.lastIndexOf('ellipsisElements') != -1 && element2.id.lastIndexOf('ellipsisElements') != -1) {
                        if (showTooltip) {
                            element1.style.display = 'none';
                            element2.style.display = '-webkit-box';
                        }
                        else {
                            element1.style.display = '-webkit-box';
                            element2.style.display = 'none';
                        }
                    }

                    i = i + 2;
                }
            },
            updateSortBy(column) {
                this.sortBy = column;
                this.sortDesc = false;

                this.selectedItem = null

                if (!this.hasSearched)
                    return;

                this.getItemsForSelectedInbox(true);
            },
            updateSortDesc(desc) {
                this.sortDesc = desc;

                this.selectedItem = null

                if (!this.hasSearched)
                    return;

                this.getItemsForSelectedInbox(true)
            },
            pageIndexChanged(pagingData) {
                this.pagingData.pageSize = pagingData.pageSize;
                this.pagingData.pageIndex = pagingData.pageIndex;

                this.getItemsForSelectedInbox(false);
            },
            validateDate(dateToRemove) {
                if (this.filter_obj.fromDate && this.filter_obj.toDate) {
                    if (this.filter_obj.fromDate > this.filter_obj.toDate) {
                        window.showAlert("res_Msgs_FromDateCompare", "warning");
                        if (dateToRemove == 'to') {
                            this.filter_obj.toDate = ''
                        } else {
                            this.filter_obj.fromDate = "2026-01-01"
                        }
                    }
                }
            },
            showAdvancedSearchDialog() {
                this.showAdvancedSearchDialogFlag = !this.showAdvancedSearchDialogFlag
            },
            handleViewDocument() { },
        },
        watch:
        {
            $route() {
                this.clearAndResetFilters();
                this.privacies = constants.privacies;
                this.priorities = constants.priorities;

                var searchHandedOver = false;
                if (this.$route.query.fromSession) {
                    if (!utils.CheckIfNullOrEmpty(sessionStorage.getItem('advanced_search_filters'))) {
                        this.filters = utils.copyObject(JSON.parse(sessionStorage.getItem('advanced_search_filters')), this.filters);
                        sessionStorage.setItem('advanced_search_filters', '');
                        searchHandedOver = true;
                    }
                }

                if (searchHandedOver)
                    this.applyFilters();
                else {
                    this.correspondences = [];
                    this.inboxes[0].count = 0;
                    this.hasSearched = false;
                }
            }
        }
    }
</script>

<style>
    .v-popper--theme-tooltip {
        max-width: 400px !important;
    }

    .cts-pane tr td .subjectCell {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        word-break: break-word;
    }

    .tr-bold td {
        font-weight: 600 !important;
    }

    .show-tooltip {
        /* Add your tooltip styles here */
        /* For example: */
        position: relative;
        cursor: pointer;
    }

        .show-tooltip::before {
            content: attr(title);
            position: absolute;
            top: -20px;
            left: 0;
            background-color: #000;
            color: #fff;
            padding: 5px;
            border-radius: 3px;
            opacity: 0.8;
            /* Additional tooltip styling */
        }

    .inbox_tab_name {
        text-transform: none !important;
    }

    tr.custom-class {
        background: #F0F8FF;
    }

        tr.custom-class .v-icon.mdi-checkbox-blank-outline:before {
            content: "";
            width: 20px;
            height: 20px;
            border: none;
            border-radius: 4px;
            background-color: #205cdf;
            background-image: url(../assets/images/icons/tick.svg);
            background-repeat: no-repeat;
            background-position: center;
            background-size: 10px;
        }

    #viewerFrame {
        height: calc(100% - 39px);
    }

    /* .v-dialog__content.v-dialog__content--active {
        background: transparent !important;
    } */

    .transparentBg {
        background: transparent !important;
    }

    .custom-button {
        background: none !important;
        padding: 0 !important;
        margin: 0 !important;
    }
</style>